import { Helmet } from "react-helmet";

const SIL = () => {
  return (
    <main>
      <Helmet>
        <title>Supported Independent Living | Provido</title>
        <meta
          property="og:title"
          content="Supported Independent Living | Provido"
        />
        <meta
          name="description"
          content="We can provide support in the home including 24 hour and overnight care."
        ></meta>
        <meta
          property="og:url"
          content="https://provido.com.au/services/supported-independent-living"
        />
        <meta
          name="twitter:title"
          content="Supported Independent Living | Provido"
        />
      </Helmet>

      {/* Page Header */}
      <div className="w-dvw bg-lightblue bg-[url(./assets/images/bubblebg.webp)] pt-12">
        <div className="mx-6 grid grid-cols-1 gap-12 pb-12 lg:mx-12">
          <div className="pb-6 text-center font-display text-6xl leading-18 text-blue sm:pb-0">
            Supported Independent Living
          </div>
          <p className="mx-6 lg:mx-24">
            Our Supported Independent Living (SIL) services help participants
            live as independently as possible while receiving the support they
            need in a safe and supportive home environment.
            <br />
            <br />
            We provide personalised supports that promote independence, build
            daily living skills, and empower participants to achieve their goals
            while maintaining choice and control over their everyday lives.
          </p>
        </div>
      </div>

      {/* How We Can Help You */}
      <div className="px-6 py-16">
        <div className="mx-auto w-fit">
          <div className="flex flex-col justify-center">
            <h2 className="pb-12 text-center font-display text-4xl text-purple">
              How We Can Help You
            </h2>
            <h3 className="pb-1 font-display text-xl text-blue">
              Our Supported Independent Living services may assist with:
            </h3>
            <ul className="text-list">
              <li>Daily personal care and hygiene</li>
              <li>Meal planning and preparation</li>
              <li>Household tasks and cleaning</li>
              <li>Medication support</li>
              <li>Developing daily living skills</li>
              <li>Building independence and confidence</li>
              <li>Establishing routines</li>
              <li>Community participation and social engagement</li>
              <li>Overnight support</li>
              <li>24/7 supported living arrangements</li>
            </ul>
          </div>
        </div>
      </div>

      {/* Who We Support */}
      <div className="w-dvw bg-skyblue bg-[url(./assets/images/darkbubblebg.webp)] px-8 py-24">
        <div className="mx-auto max-w-3xl text-white">
          <h2 className="pb-8 text-center font-display text-3xl text-blue lg:text-4xl">
            Who We Support?
          </h2>
          <p>
            We support participants living with a wide range of disabilities and
            support needs, including:
          </p>
          <ul className="text-list">
            <li>Intellectual disabilities</li>
            <li>Autism Spectrum Disorder (ASD)</li>
            <li>Physical disabilities</li>
            <li>Neurological conditions</li>
            <li>Psychosocial disabilities</li>
          </ul>
          <p>
            We are committed to creating supportive living environments where
            participants can develop skills, build confidence, and enjoy greater
            independence in their daily lives.
          </p>
        </div>
      </div>
    </main>
  );
};

export default SIL;
